// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/utils/parse-user-agent.ts
// Parameters       : none — this file is byte-identical across the fleet
// Destination      : packages/fleet/utils/src/parse-user-agent.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo listto-app
//     node fleet/fleet.ts check --repo listto-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import type { MessageDescriptor } from "@lingui/core";

function detectOS(ua: string): string {
  if (ua.includes("Windows")) {
    return "Windows";
  }
  if (ua.includes("Mac OS X") || ua.includes("Macintosh")) {
    return "macOS";
  }
  if (ua.includes("Android") || ua.includes("okhttp")) {
    return "Android";
  }
  if (ua.includes("Linux")) {
    return "Linux";
  }
  if (ua.includes("iPhone") || ua.includes("iPad") || ua.includes("CFNetwork")) {
    return "iOS";
  }
  return "";
}

function detectBrowser(ua: string): string {
  if (ua.includes("Edg")) {
    return "Edge";
  }
  if (ua.includes("Chrome") || ua.includes("CriOS")) {
    return "Chrome";
  }
  if (ua.includes("Firefox") || ua.includes("FxiOS") || ua.includes("Fennec")) {
    return "Firefox";
  }
  if (ua.includes("Safari") && !ua.includes("Chrome") && !ua.includes("CriOS")) {
    return "Safari";
  }
  return "";
}

export function parseUserAgent(
  ua: string | undefined,
  translate: (descriptor: MessageDescriptor) => string,
): string {
  if (!ua) {
    return translate({ id: "Unknown device", message: "Unknown device" });
  }

  const os = detectOS(ua);

  if (ua.includes("Electron")) {
    return os
      ? `${translate({ id: "Desktop App", message: "Desktop App" })} (${os})`
      : translate({ id: "Desktop App", message: "Desktop App" });
  }

  const browser = detectBrowser(ua);

  if (browser) {
    return os ? `${browser} (${os})` : `${browser} (Web)`;
  }

  if (os) {
    return `${translate({ id: "App", message: "App" })} (${os})`;
  }

  const MAX_UA_LENGTH = 40;
  return ua.slice(0, MAX_UA_LENGTH);
}
